import { useEffect, useState } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { getAuthToken, acquireToken, exchangeToken, getSsoJwt, clearSsoSession } from "./auth";
import LoginPage from "./LoginPage";
import App from "./App";

export default function AppShell({ ssoEnabled }: { ssoEnabled: boolean }) {
  const { instance } = useMsal();
  const isMsalAuthenticated = useIsAuthenticated();
  const [ssoError, setSsoError] = useState<string | null>(null);
  const [ready, setReady] = useState(false);

  // After MSAL redirect login, exchange Azure token for Strapi JWT
  useEffect(() => {
    if (!ssoEnabled || !isMsalAuthenticated || getSsoJwt()) {
      setReady(true);
      return;
    }
    (async () => {
      try {
        const azureToken = await acquireToken();
        if (azureToken) {
          const result = await exchangeToken(azureToken);
          if (!result) setSsoError("Token exchange failed. Your account may not exist in the system.");
        }
      } catch {
        setSsoError("SSO login failed.");
      }
      setReady(true);
    })();
  }, [ssoEnabled, isMsalAuthenticated]);

  if (!ready) return null;

  const isAuthenticated = !!getAuthToken();

  if (!isAuthenticated) {
    return (
      <LoginPage
        ssoEnabled={ssoEnabled}
        onSsoLogin={() => {
          setSsoError(null);
          instance.loginRedirect({ scopes: ["User.Read"] });
        }}
        ssoError={ssoError}
      />
    );
  }

  return <App ssoEnabled={ssoEnabled} onLogout={async () => {
    clearSsoSession();
    const accounts = instance.getAllAccounts();
    if (accounts.length > 0) {
      await instance.logoutRedirect({ postLogoutRedirectUri: window.location.origin });
    } else {
      window.location.reload();
    }
  }} />;
}
